import React from 'react';
import './WizardStepper.css';

export const WIZARD_STEPS = [
  { label: 'Dados' },
  { label: 'Endereço' },
  { label: 'Dependentes' },
  { label: 'Declarante' },
  { label: 'Documentos' },
  { label: 'Facial' },
  { label: 'Protocolo' },
] as const;

interface WizardStepperProps {
  /** número da etapa atual, de 1 a WIZARD_STEPS.length */
  current: number;
}

const WizardStepper: React.FC<WizardStepperProps> = ({ current }) => (
  <nav className="ui-stepper" aria-label={`Etapa ${current} de ${WIZARD_STEPS.length}`}>
    {WIZARD_STEPS.map((step, idx) => {
      const stepNo = idx + 1;
      const status = stepNo < current ? 'done' : stepNo === current ? 'active' : 'upcoming';
      return (
        <div className={`ui-step ui-step--${status}`} key={step.label}>
          <div className="ui-step__dot" aria-hidden="true">
            {status === 'done' ? '✓' : stepNo}
          </div>
          <div className="ui-step__label">{step.label}</div>
        </div>
      );
    })}
  </nav>
);

export default WizardStepper;
